import { ICommonResponse } from 'api/types';
import { AcademicYearTitle } from 'components/pdfStudent';
import { splittedDataToSortedArray } from 'containers/pdfStudent/utils/splittedDataToSortedArray';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetStudyDocuments } from 'icons/widgets';
import DocumentCard from 'portfolio3/features/pdf/components/cards/DocumentCard';
import GridLayout from 'portfolio3/features/pdf/components/GridLayout';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { IStudyDocumentEntity } from 'types';
import { getAcademicYearByDate, getDataLoadRequests, isDateValid } from 'utils';

import { studyDocumentsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const splitDocumentsByAcademicYear = (data: ICommonResponse<IStudyDocumentEntity>, academicYears: string[]) => {
  const learningYearData: Record<string, IStudyDocumentEntity[]> = {};

  data.content.forEach((item) => {
    const date = new Date(item.formData.issueDate);

    if (!isDateValid(date)) {
      return;
    }

    const period = getAcademicYearByDate(date);
    if (academicYears.includes(period)) {
      if (learningYearData[period]) {
        learningYearData[period].push(item);
      } else {
        learningYearData[period] = [item];
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};

const PdfDocumentsContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const documents = useAppSelector(studyDocumentsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().studySpoDocuments });

  const hasData = documents.content.length > 0;

  const academicYearData = splitDocumentsByAcademicYear(documents, academicYears);
  return (
    <PdfCommonDataEntityContainer title="Документы" Icon={IconWidgetStudyDocuments}>
      {hasData &&
        academicYearData.map(([academicYear, data]) => (
          <div key={academicYear}>
            <AcademicYearTitle academicYear={academicYear} />
            <GridLayout gap="16px">
              {data.map((entity) => (
                <DocumentCard
                  key={entity.formData.id}
                  name={entity.name}
                  badge={entity.badge}
                  preview={undefined}
                  previewPlaceholderText="JPG"
                />
              ))}
            </GridLayout>
          </div>
        ))}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfDocumentsContainer;
